import React from 'react'
import styled from '../../theme/styled'

const CheckboxWrapper = styled.div`
  label {
    padding: 0;
  }

  input {
    margin-right: 10px;
    margin-top: 5px;
  }
`

export type RadioProps = {
  isChecked: boolean
  label: string
  value: string
}

const CustomRadio = props => {
  const { label, input, isChecked, value } = props

  const handleChange = event => {
    input.onChange(event.target.value)
  }

  return (
    <CheckboxWrapper>
      <label>
        <input
          type="radio"
          value={value}
          checked={isChecked}
          onChange={handleChange}
        />
        {label}
      </label>
    </CheckboxWrapper>
  )
}

export default CustomRadio



// WEBPACK FOOTER //
// ./src/Components/Shared/CustomRadio.tsx